// src/components/RequirePremium.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isSubscribed } from "../utils/subscription";

export default function RequirePremium({ children }) {
  const location = useLocation();
  const [ok, setOk] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const y = await isSubscribed();
      if (mounted) setOk(y);
    })();
    return () => (mounted = false);
  }, []);

  if (ok === null) return <div className="p-8 text-center">Checking access…</div>;
  if (!ok) {
    const back = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/subscribe?need=premium&back=${back}`} replace />;
  }
  return children;
}
